import type { FilterState } from '@supply-mover-2-0/core';
import { AuthService, TokenResolverService } from '@supply-mover-2-0/core';

/**
 * Resolve the "Me" token in list filter state for an outgoing request
 * (PD-15272).
 *
 * The list builder keeps the `ME` token itself in filter state, so a list
 * saved or shared while "Me" is selected keeps meaning "whoever is looking",
 * and the chip reads "Me". Requests still send the viewer's own user id, as
 * they always have, because not every list endpoint resolves the token
 * server-side (a filter whose values are sent as numbers would turn `ME` into
 * nothing and drop the filter). Call this wherever list filter state leaves
 * the browser; everything else about the state is returned untouched.
 */
export function resolveMeTokenForRequest(filters: FilterState): FilterState {
	const authState = AuthService.getInstance().getAuthState();
	const context = TokenResolverService.createContextFromAuth(authState);

	return TokenResolverService.resolveMeTokens(filters, context);
}
